import React, {useState,useEffect,useContext, useCallback} from "react";
import {useNavigate,useParams} from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";

const ModificacionContrato = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { authFetch } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] =  useState("");
  const [success, setSuccess] =  useState("");

  // ==========================
  // INFO CONTRATO ORIGINAL
  // ==========================

  const [contrato, setContrato] =  useState(null);
  const [modificaciones, setModificaciones] = useState([]);

  // ==========================
  // FORM
  // ==========================

  const [formData, setFormData] = useState({

      id_informacion_general: Number(id),
      tipo_cobertura: "",
      cobertura_contratada: "",
      lugar_ejecucion: "",
      plazo_pago: ""

  });

  
  const loadModificaciones = useCallback(async () => {

    try {

      const res = await authFetch(
        `${ENDPOINTS.get_modificaciones_contrato}?id_informacion_general=${id}`
      );

      if (res.success) {

        setModificaciones(res.data);

      } else {

        setModificaciones([]);

      }

    } catch (error) {

      console.error(error);

      setModificaciones([]);

    }

  }, [id, authFetch]);

  // ==========================
  // CARGAR CONTRATO
  // ==========================
  useEffect(() => {

    const loadContrato = async () => {

      try {

        const res = await authFetch(
          `${ENDPOINTS.getById_informacion_general}?id=${id}`
        );

        if (res.success) {
          setContrato(res.data);
        }

      } catch (error) {

        console.error(error);

        setError("Error cargando contrato");

      }

    };

    const loadData = async () => {

      setLoading(true);

      await loadContrato();
      await loadModificaciones();

      setLoading(false);

    };

    loadData();

  }, [id, authFetch, loadModificaciones]);

  // ==========================
  // INPUTS
  // ==========================

  const handleChange = (e) => {

    const {name,value} = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

  };


  // ==========================
  // GUARDAR
  // ==========================

  const handleSubmit = async (e) => {

    e.preventDefault();

    setError("");
    setSuccess("");

  const hayModificacion =
      formData.tipo_cobertura.trim() !== "" ||
      formData.cobertura_contratada.trim() !== "" ||
      formData.lugar_ejecucion.trim() !== "" ||
      formData.plazo_pago.trim() !== "";

  if (!hayModificacion) {

      setError("Debe diligenciar al menos un campo para registrar la modificación.");
      return;
  }

    try {

      const res =
        await authFetch(ENDPOINTS.create_modificacion_financiera,
          {

            method: "POST",

            headers: {
              "Content-Type":
                "application/json"
            },

            body: JSON.stringify(formData)

          }
        );

      if (!res.success) {

        setError(res.message);
        return;

      }

      setSuccess("Modificación registrada correctamente");
      await loadModificaciones();
      setFormData({
          id_informacion_general: Number(id),
          tipo_cobertura: "",
          cobertura_contratada: "",
          lugar_ejecucion: "",
          plazo_pago: ""
      });

    } catch (error) {

      console.error(error);
      setError("Error del servidor");

    }

  };

  // ==========================
  // LOADING
  // ==========================

  if (loading) {

    return (
      <p>Cargando...</p>
    );

  }

  return (

    <div className="p-4">

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h3>Registrar Modificación Contractual</h3>

        <button className="btn btn-outline-pink" onClick={() => navigate("/session/mod_administrativa/informacion_general/informacion_general")}>
        <i className="bi bi-arrow-left me-1"></i>
          Volver
        </button>

      </div>

      {/* CONTRATO BASE */}

      {contrato && (

        <div className="card mb-4">

          <div className="card-header">Contrato Original</div>

          <div className="card-body">

            <div className="row">

              <div className="col-md-6">
                <strong>Área:</strong>
                <br />
                {contrato.area_name}
              </div>

              <div className="col-md-6">
                <strong>Programa:</strong>
                <br />
                {contrato.program_name}
              </div>

              <div className="col-md-6 mt-3">
                <strong>Contratante:</strong>
                <br />
                {contrato.contratante}
              </div>

              <div className="col-md-6 mt-3">
                <strong>Tipo de cobertura original:</strong>
                <br />
                {contrato.tipo_cobertura || "-"}
              </div>

              <div className="col-md-6 mt-3">
                <strong>Cobertura original:</strong>
                <br />
                {contrato.cobertura || "-"}
              </div>

              <div className="col-md-6 mt-3">
                <strong>Lugar de ejecución original:</strong>
                <br />
                {contrato.lugar_ejecucion || "-"}
              </div>

              <div className="col-md-6 mt-3">
                <strong>Plazo de pago original:</strong>
                <br />
                {contrato.plazo_pago || "-"}
              </div>

              <div className="col-md-6 mt-3">
                <strong>Fecha fin original:</strong>
                <br />
                {contrato.fecha_fin}
              </div>

              <div className="col-md-6 mt-3">
                <strong>Valor original:</strong>
                <br />
                ${
                    contrato.valor_contrato_antes_iva
                      ? Number(
                          contrato.valor_contrato_antes_iva
                        ).toLocaleString()
                      : "-"
                  }
              </div>

            </div>

          </div>

        </div>

      )}

      <form className="card p-4" onSubmit={handleSubmit}>

        {error && (
          <div className="alert alert-danger">{error}</div>
        )}

        {success && (
          <div className="alert alert-success">{success}</div>
        )}

        <div className="row">

          {/* TIPO DE COBERTURA */}
          <div className="col-md-3 mb-3">

            <label className="form-label">Tipo de Cobertura</label>

            <input
              type="text"
              name="tipo_cobertura"
              className="form-control"
              value={formData.tipo_cobertura}
              onChange={handleChange}
              placeholder="Ingrese el nuevo tipo de cobertura"
            />

          </div>

          {/* COBERTURA */}
          <div className="col-md-3 mb-3">

            <label className="form-label">Cobertura</label>

            <input
              type="text"
              name="cobertura_contratada"
              className="form-control"
              value={formData.cobertura_contratada}
              onChange={handleChange}
              placeholder="Ingrese la nueva cobertura"
            />

          </div>

          {/* LUGAR DE EJECUCIÓN */}
          <div className="col-md-3 mb-3">

            <label className="form-label">Lugar de Ejecución</label>

            <input
              type="text"
              name="lugar_ejecucion"
              className="form-control"
              value={formData.lugar_ejecucion}
              onChange={handleChange}
              placeholder="Ingrese el nuevo lugar de ejecución"
            />

          </div>

          {/* PLAZO DE PAGO */}
          <div className="col-md-3 mb-3">

            <label className="form-label">Plazo de Pago</label>

            <input
              type="text"
              name="plazo_pago"
              className="form-control"
              value={formData.plazo_pago}
              onChange={handleChange}
              placeholder="Ingrese el nuevo plazo de pago"
            />

          </div>

        </div>
        <button type="submit" className="btn btn-outline-pink w-100 mt-3">
          Registrar Modificación
        </button>

      </form>

      {/* HISTORIAL DE MODIFICACIONES */}
      <div className="card mt-4">

        <div className="card-header">Historial de Modificaciones</div>

        <div className="card-body">

          {modificaciones.length === 0 ? (

            <div className="alert alert-light">No existen modificaciones registradas.</div>

          ) : (

            <div className="table-responsive">

              <table className="table table-bordered table-hover">
                <thead>

                  <tr>

                    <th>Tipo de Cobertura</th>
                    <th>Cobertura</th>
                    <th>Lugar de Ejecución</th>
                    <th>Plazo de Pago</th>
                    <th>Fecha Registro</th>

                  </tr>

                </thead>
                <tbody>

                  {modificaciones.map((item) => (

                    <tr key={item.id}>

                      <td>{item.tipo_cobertura || "-"}</td>
                      <td>{item.cobertura_contratada || "-"}</td>
                      <td>{item.lugar_ejecucion || "-"}</td>
                      <td>{item.plazo_pago || "-"}</td>
                      <td>
                        {
                          new Date(item.created_at)
                            .toLocaleString(
                              "es-CO",
                              {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true
                              }
                            )
                        }
                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>

    </div>

  );

};

export default ModificacionContrato;